import PropTypes from "prop-types";
import { useEffect, useState } from "react";

const CatalogSimpleSearch = ({
  value = "",
  placeholder = "Cerca...",
  buttonLabel = "Cerca",
  buttonTooltip = "",
  onSearch,
  className = "",
}) => {
  const [draft, setDraft] = useState(value);

  useEffect(() => {
    setDraft(value);
  }, [value]);

  const submit = () => {
    onSearch?.(draft.trim());
  };

  return (
    <div className={`cm-search-inline ${className}`.trim()}>
      <input
        type="search"
        className="cm-input"
        placeholder={placeholder}
        value={draft}
        onChange={(event) => setDraft(event.target.value)}
        onKeyDown={(event) => {
          if (event.key === "Enter") {
            event.preventDefault();
            submit();
          }
        }}
      />
      <button type="button" className="cm-btn cm-btn-secondary" onClick={submit} title={buttonTooltip || undefined}>
        {buttonLabel}
      </button>
    </div>
  );
};

CatalogSimpleSearch.propTypes = {
  value: PropTypes.string,
  placeholder: PropTypes.string,
  buttonLabel: PropTypes.string,
  buttonTooltip: PropTypes.string,
  onSearch: PropTypes.func,
  className: PropTypes.string,
};

export default CatalogSimpleSearch;
